module.exports = require('./Switch');


//////////////////
// WEBPACK FOOTER
// ./~/rc-switch/es/index.js
// module id = 1531
// module chunks = 3